<template>
<v-menu v-model="menuAvatar" offset-y lazy :close-on-content-click="false">
  <template v-slot:activator="{ on }">
    <v-btn flat v-on="on" style="min-width:24px;">
      <v-avatar size="40">
        <v-img :src="userAvatar"></v-img>
      </v-avatar>
    </v-btn>
  </template>
  <v-card>
    <v-list>
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title>{{userName}}</v-list-tile-title>
          <v-list-tile-sub-title>{{userMail}}</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat small color="primary" @click="signOut">{{ $t('menu.logout') }}</v-btn>
    </v-card-actions>
  </v-card>
</v-menu>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'

export default {
  name: 'UserAvatarMenu',
  mixins: [UserAuth],
  data() {
    return {
      menuAvatar: false
    }
  },
  methods:{
    signOut() {
      this.$auth.signOut();
      window.location.href = '/';
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/utils/UserAvatarMenu.vue